import React from 'react';

const NotFound = () => {
    return (
        <div>
            your requested page is not found
        </div>
    );
};

export default NotFound;